import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { UserService } from './../../services/user.service';
import { SLAKPIApiService } from './../../services/slakpi.service';
import { kpiInbox, kpiUserActivities, year } from './../../models/slakpi';
declare var jquery: any;
declare var $: any;
import { SpinnerVisibilityService } from 'ng-http-loader';
import { Router } from '@angular/router';
import { tenant, usermaster, userpermission } from '../../models/admin';
import { AdminApiService } from '../../services/admin.service';
import { slaNote, userrights } from '../../models/users';
import { environment } from '../../../environments/environment';
import { RSAHelper } from '../../models/RSAHelper';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit {
  public sli_data: any;
  public yearData: any;
  public quaterData: any;
  public division_data: any;
  public frequency_data: any;
  public slaUno?: number = 0;
  public yearUno?: number = 0;
  public quarterUno?: number = 0;
  public divisionUno?: number = 0;
  public frequencyUno?: number = 0;
  // custom code end
  public startAngle: number = 0;
  public endAngle: number = 360;
  public radius: string = 'r';
  public enableAnimation: boolean = true;
  public enableSmartLabels: boolean = true;
  public tooltip: Object = {
    enable: true
  };
  public user: any = {};
  public KPIAcitvities_data: any = [];
  public StartIndex: number = 1;
  public MaxCount: number = 10;
  public disableMore: boolean = true;
  isAdmin: boolean = false;
  public login_UserID: string; // number
  currentYear?: number=0;
  currentHalf?: number;
  currentQuarter?: number=0;
  currentMonth?: number;
  public filterDataCollectionCount: number = 0;
  public filterOverdueCount: number = 0;
  public filterCompletedCount: number = 0;
  public filterApprovalCount: number = 0;
  public nitifyCount: number = 0;
  public desingation: string = '';
  public division: string = '';
  public displayname: string = '';

  public role: string = '';
  public picture: string = '';
  public lastLogin: string = '';
  index = 0;
  speed = 2000;
  infinite = true;
  direction = 'right';
  directionToggle = true;
  autoplay = true;
  tenantUno: any = 1;
  public kpiDashboard_data_chart_report: any = [];
  public legendSettings: Object = {
    visible: true,
    toggleVisibility: false,
    position: 'Bottom',
    height: '28%',
    width: '50%'
  };
  public map: Object = 'fill';

  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  showMyContainer: boolean = false;
  multiTenantList: any = [];
    user_data: any;
    tenant_data: any;
    bscKPIUrl: string='';
  constructor(private userService: UserService, public restApi: SLAKPIApiService, private router: Router, private spinner: SpinnerVisibilityService, public restApiadmin: AdminApiService, public RASHelper: RSAHelper) {
    //code

    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (this.isBMChampion || this.isBMTeam || this.isBMVisitor || this.isBMAdmin) {
      this.router.navigateByUrl('/benchmark-home');
    }

  }

  ngOnInit() {
    this.bscKPIUrl = window.location.origin + '/bsc/dashboard';
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    
    this.login_UserID = this.user.id;
    this.desingation = this.user.desingation;
    this.displayname = this.user.displayname;
    this.role = this.user.role;
    this.picture = this.user.profilePicture;
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin') ? true : false;
    this.lastLogin = this.user.lastLogin;
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.division = this.user.division;
    
    this.viewKPIAcitvities();
    this.loadTenant();
    this.loadUserMaster();
    //let temp = this;
    //setTimeout(() => {
    //  temp.getUserPermissionEntry(temp.login_UserID);
    //}, 500);
    
    //this.loadFrequency();
    //this.loadFilterValues();
    let ft = document.getElementById("footer");
    if (ft != null && ft != undefined) {
      ft.style.display = 'block';
    }
    let ft1 = document.getElementById("main-menu");
    if (ft1 != null && ft1 != undefined) {
      ft1.style.display = 'block';
    }
  }

  exportToExcel() {
  }

  viewKPIAcitvities() {

    this.KPIAcitvities_data = [];
    let inpValue = new kpiUserActivities();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.StartIndex = (this.StartIndex == undefined || this.StartIndex < 1) ? 1 : this.StartIndex;
    inpValue.startIndex = this.StartIndex;
    inpValue.maxCount = 4;

    this.restApi.getKpiUserActivities(inpValue)
      .subscribe(data => {

        let objData: any = data;
        if (this.StartIndex == 1) {
          this.KPIAcitvities_data = [];
          for (var i = 0; i < objData.length; i++) {
            
            var test = objData[i].postedDate.split(/\s+/);
            objData[i].postedDate = test[0] + ' ' + test[1] + ' ' + test[2];//+ ' ' + test[3];
            objData[i].PostedBy = test[3];
            this.KPIAcitvities_data.push(objData[i]);
          }

        }
        else {
          for (var i = 0; i < objData.length; i++) {
            var test = objData[i].postedDate.split(/\s+/);
            objData[i].postedDate = test[0] + ' ' + test[1] + ' ' + test[2];// + ' ' + test[3];
            objData[i].PostedBy = test[3];
            this.KPIAcitvities_data.push(objData[i]);
          }
        }
        //if the result set is lessthen 10 then disable the load more icon
        this.disableMore = (objData.length >= 15) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.StartIndex = this.StartIndex + 1;
        }

      },
        (error) => {
          //Called when error
          // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  loadKPIInboxCount() {
    

    let inpValue = new kpiInbox();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.currentYear = (this.yearUno)? this.yearUno :this.currentYear;
    inpValue.currentQuarter = (this.quarterUno) ? this.quarterUno : this.currentQuarter;
    inpValue.currentMonth = 0;//this.currentMonth;
    inpValue.currentHalf = 0;//this.currentHalf;
    inpValue.filterDataCollection = 1;
    inpValue.filterOverdue = 0;
    inpValue.filterApproval = 0;
    inpValue.filterCompleted = 0;
    inpValue.isAdmin = this.isAdmin;
    
    this.restApi.getKpiInboxCount(inpValue)
      .subscribe(data => {
        let rtnData: any = data;
        //this.kpiInbox_data_count = data[0];
        this.filterDataCollectionCount = rtnData.data[0].filterDataCollectionCount;
        this.filterCompletedCount = rtnData.data[0].filterCompletedCount;
        this.filterApprovalCount = rtnData.data[0].filterApprovalCount;
        this.filterOverdueCount = rtnData.data[0].filterOverdueCount;

        this.kpiDashboard_data_chart_report = [
          { x: 'Data Entry[' + this.filterDataCollectionCount.toString() + ']', y: this.filterDataCollectionCount, r: "Data Entry" },
          { x: 'Completed[' + this.filterCompletedCount.toString() + ']', y: this.filterCompletedCount, r: "Completed" },
          { x: 'Approval[' + this.filterApprovalCount.toString() + ']', y: this.filterApprovalCount, r: "Approval" }
        ];

      },
        (error) => {

        }
      ).add(() => {

      });
  }


  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {

        let objdata: any = data;
        this.sli_data = objdata.list_SLAMaster;
        this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        let temp = this;
        setTimeout(() => {
          this.yearUno = (temp.currentYear) ? Number(temp.currentYear) : 0;
          this.quarterUno = (temp.currentQuarter) ? Number(temp.currentQuarter) : 0;
        }, 500);
        
        this.loadKPIInboxCount();
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }
  loadFrequency() {
    this.frequency_data = [
      { frequencyCode: 1, frequencyName: 'Yearly' },
      { frequencyCode: 2, frequencyName: 'Semi-annually' },
      { frequencyCode: 3, frequencyName: 'Quarterly' },
      { frequencyCode: 4, frequencyName: 'Monthly' }
    ];

     

  }

  onClickInbox(type:string) {
    this.router.navigate(['/inbox/' + type]);
    return false;
  }

  // Get user list
  loadUserMaster() {
    let currPage = this;
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = "1";
    inpValue.ntLogin = this.user.username;
    
    this.restApiadmin.getUserMasters(inpValue)
      .subscribe(data => {
        //debugger;
        if (data != null) {
          let rtnData: any = data;
          this.user_data = rtnData.data[0];
          currPage.getUserPermissionEntry(currPage.login_UserID);
        }
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  getUserPermissionEntry(selectedUserUno: any) {
    //debugger;

    let inpValue = new userpermission();
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.userUno = selectedUserUno;
    inpValue.enteredBy = this.login_UserID;
    //inpValue.tenantUno = this.tenantUno;
    
    this.restApiadmin.getUserPermission(inpValue)
      .subscribe(data => {
        //debugger;
        let rtndata: any = data;

        const mockDataset = [];

        if (this.user_data != undefined && this.user_data != null && this.user_data != '') {
          mockDataset[0] = {

            tenantUno: this.user_data.tenantUno,
            tenantName: this.getTenantName(this.user_data.tenantUno),
            divisionUno: this.user_data.divisionUno,
            divisionName: this.user_data.divisionNameEn,
            userTypeUno: this.user_data.userTypeUno,
            userTypeName: this.user_data.userTypeNameEn,
            userRoleUno: this.user_data.usergroupUno,
            userRoleName: this.user_data.usergroupEn
          };
        }
        
        for (let i = 0; i < rtndata.length; i++) {
          mockDataset[i + 1] = {
            tenantUno: rtndata[i].tenantUno,
            tenantName: rtndata[i].tenant,
            divisionUno: rtndata[i].divisionUno,
            divisionName: rtndata[i].divisionName,
            userTypeUno: rtndata[i].userTypeUno,
            userTypeName: rtndata[i].userType,
            userRoleUno: rtndata[i].userRoleUno,
            userRoleName: rtndata[i].userRole
          };
        }

        if (mockDataset.length > 0) {
          this.multiTenantList = mockDataset.sort((a, b) => a.tenantUno - b.tenantUno);
        } else {
          this.multiTenantList = [];
        }

      },
        (error) => {
          //Called when error
         
        }
      ).add(() => {

        //Called when operation is complete (both success and error)

      });

  }

  getTenantName(id: any) {
    //debugger;
    if (this.tenant_data != null && this.tenant_data.length > 0) {
      var objTenant = this.tenant_data.filter(item => item.tenantUno == id);
      if (objTenant.length > 0) {
        return objTenant[0].tenantNameEn;
      } else { return ""; }
    }
    else { return ""; }

  }

  loadTenant() {

    let inpValue = new tenant();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;//this.RASHelper.encryptWithPublicKey('2');
    this.restApiadmin.getTenants(inpValue)
      .subscribe(data => {
        
        this.tenant_data = data;


      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  onredirectPage(page: any) {
    //debugger;
    if (page == 'inbox') {
      window.location.href = "#/inbox/dataentry";
    }
    else if (page == 'sladashboard') {
      window.location.href = "#/sladashboard/general";
    }
    else if (page == 'slaperformance') {
      window.location.href = "#/dashboard-slaperformance";
    }
    else if (page == 'digitaldashboard') {
      window.location.href = "#/dashboard-digital";
    }
    else if (page == 'moro') {
      window.location.href = "#/slakpiperformance?pagetype=Moro";
      window.location.reload();
    }
    else if (page == 'digitalx') {
      window.location.href = "#/slakpiperformance?pagetype=DigitalX";
      window.location.reload();
    }
    else if (page == 'infrax') {
      window.location.href = "#/slakpiperformance?pagetype=InfraX";
      window.location.reload();
    }
    else {
      window.location.href = "#/dashboard";
    }

    return false;
  }

  redirectPage(page: any, item: any) {
    if (item.tenantUno == this.tenantUno) {
      this.onredirectPage(page);
    }
    else {
      this.SwitchTenant(item, page);
    }
  }

  SwitchTenant(item: any, pageType: any) {
    //debugger;
    var strTenant = '{"id":"' + 1 + '"}';
    localStorage.removeItem('switchTenant');
    localStorage.setItem('switchTenant', strTenant);

    //this.getTenantInfo(item.tenantUno, item, pageType);
    this.userService.getTenantInfo(item.tenantUno, item, pageType);
    return false;
  }
}
